import { BackIcon } from '../../../../assets/images/Icons/BackIcon';
import { COLORS } from '../../../../config/designSystem/Colors';
import { GuidedBreathingModeArray } from '../../../../types/breathing';
import { H3, H4, ParagraphSRegular } from '../../../../config/designSystem/typography';
import { SelectorList } from '../../../../components/Selector/SelectorList';
import { Switch, TouchableOpacity, View } from 'react-native';
import { breatheKey, breatheStackKey } from '../../../../constants/routeKeys';
import { concatPath } from '../../../../utils/links/concatPath';
import { isWeb } from '../../../../config/designSystem/Layout';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useStores } from '../../../../hooks/useStores';


export const BreatheSettings = observer(() => {
  const rootStore = useStores();

  const stepVibrationFlag = rootStore?.technique.getStepVibrationFlag;
  const guidedBreathingMode = rootStore?.technique.getGuidedBreathingMode;

  const labels = rootStore?.language?.translate?.MOBILE?.SNACKING?.BREATHE;
  const data = GuidedBreathingModeArray.map(val => {
    let label = '';
    switch(val) {
    case 'laura':
      label = labels?.LAURA?labels.LAURA: 'Laura';
      break;
    case 'paul':
      label = labels?.PAUL?labels.PAUL: 'Paul';
      break;
    case 'bell':
      label = labels?.BELL?labels.BELL: 'Bell';
      break;
    case 'disabled':
      label = labels?.DISABLED?labels.DISABLED: 'Disabled';
      break;
    }
    return {
      _id: val,
      label
    };
  });

  const goBack = () => {
    if(router.canGoBack()){
      router.back();
    } else {
      router.navigate(concatPath([breatheStackKey, breatheKey], 0) as string);
    }
  };






  return (
    <View style={{marginTop:70, marginHorizontal:30, rowGap: 40}}>
      <View style={{flexDirection:'row'}} >
        <TouchableOpacity style={{marginLeft:10}}  onPress={goBack} >
          <BackIcon tintColor={COLORS.brand[500]} />
        </TouchableOpacity>
        <View style={{width:'70%'}}>
          <H3 align={true}>
            {labels?.SETTINGS?labels.SETTINGS: 'Settings'}
          </H3>
        </View>

      </View>
      <View>
        <View style={{rowGap:5}}>
          <H4>
            {labels?.SOUNDS?labels.SOUNDS: 'Sounds'}
          </H4>
          <ParagraphSRegular>
            {labels?.EXPLANATION?labels.EXPLANATION: 'Guided or silent breathing exercise'}
          </ParagraphSRegular>
        </View>
        <View >
          <SelectorList data={data} noHeightDefined={true} selectedItem={guidedBreathingMode} onSelect={(val, idx) => {rootStore?.technique.setGuidedBreathingMode(val);}} />
        </View>
      </View>
      {!isWeb && <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
        <View style={{rowGap:5, flex:1}}>
          <H4>
            {labels?.VIBRATION?labels.VIBRATION: 'Vibration'}
          </H4>
          <View style={{maxWidth:'100%'}}>
            <ParagraphSRegular>
              {labels?.EXPLANATION_VIBRATION?labels.EXPLANATION_VIBRATION: 'When finishing a cycle of breathing'}
            </ParagraphSRegular>
          </View>
        </View>
        <View>
          <Switch
            style={{ transform: [{ scaleX: 0.6 }, { scaleY: 0.6 }], alignSelf: 'center', marginBottom: 5 }}
            trackColor={{ false: '#767577', true: COLORS.brand[500] }}
            thumbColor={'white'}
            ios_backgroundColor="#3e3e3e"
            onValueChange={val => {
              rootStore?.technique.setStepVibrationFlag(val);
            }}
            value={stepVibrationFlag}
          />
        </View>
      </View>}
    </View>

  );
});

export default BreatheSettings;
